import React from 'react';
import { isEmbedded } from '../utils/embedding';

// #105 (S1, plan D7): the action bar of the wizard steps. Back is secondary
// with a chevron; the primary action carries a chevron only for Continue.
// Embedded = static at the end of the content (inside the container measured
// by IFrameResizer); top level = sticky at the bottom of the page scroll.
interface Props {
  onBack?: () => void;
  backLabel: React.ReactNode;
  // omitted: the bar has Back only (step 2 without methods)
  primaryLabel?: React.ReactNode;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  primaryType?: 'button' | 'submit';
  showChevron?: boolean;
  hideBack?: boolean;
}

const ChevronLeft = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15 6l-6 6 6 6" />
  </svg>
);

const ChevronRight = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M9 6l6 6-6 6" />
  </svg>
);

const ActionBar: React.FC<Props> = ({
  onBack,
  backLabel,
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  primaryType = 'button',
  showChevron = false,
  hideBack = false,
}) => {
  const mode = isEmbedded() ? 'xc-actions--embedded' : 'xc-actions--sticky';
  return (
    <div className={`xc-actions ${mode}`}>
      {!hideBack && (
        <button
          type="button"
          className="xc-btn xc-actions__back"
          onClick={onBack}
        >
          <ChevronLeft />
          {/* below 480 px only the chevron shows; the text stays the
              accessible name (portal.css width budget) */}
          <span className="xc-actions__back-text">{backLabel}</span>
        </button>
      )}
      {primaryLabel !== undefined && (
        <button
          type={primaryType}
          className="xc-btn xc-btn--primary"
          onClick={onPrimary}
          disabled={primaryDisabled}
        >
          <span>{primaryLabel}</span>
          {showChevron && <ChevronRight />}
        </button>
      )}
    </div>
  );
};

export default ActionBar;
